import { useState } from "react";
import { PrimaryButton } from "../components/buttons/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { SecondaryButton } from "../components/buttons/SecondaryButton";

export interface NoneUserRentedProps {
    icon: React.ReactNode,
    text: string,
    buttonText: string,
    buttonLink: string
}

export const NoneUserRented: React.FC<NoneUserRentedProps> = ({icon, text, buttonLink, buttonText}) => {

    const navigate = useNavigate();
    
    return (
        <div className="flex flex-col items-center justify-center min-h-[80vh]">
            {icon}
            <p className="text-gray-700">{text}</p>
            <div className="flex flex-col w-[200px] pt-6">
                <PrimaryButton title={buttonText} onClick={() => { navigate(buttonLink) }} />
                <SecondaryButton title={"Avalehele"} onClick={() => { navigate("/") }} />
            </div>

        </div>
    )
}